<template>
  <div class="main">
    <report-top
      ><template slot="search">
        <ly-search
          v-model="searchItem.keyword"
          @search="search"
        ></ly-search> </template
    ></report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">单位筛选</p>
        <selectAlotGroup
          placement="left"
          @groupIdList="
            searchItem.groupIdList = $event;
            getList();
          "
        ></selectAlotGroup>
      </div>
      <div id="ddas">
        <Button @click="getDeList(1)" size="small" icon="md-log-out"
          >转移</Button
        >
        <Button @click="exportAll" icon="md-download">导出</Button>
        <Button @click="openAdd" size="small" icon="md-add">新增</Button>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
      @on-selection-change="selectCars = $event"
    >
      <viewer v-if="!utils.isEmpty(row.pic)" slot-scope="{ row, index }" :slot="'pic'">
        <img
          :src="axios.platConfig.fileUri + row.pic"
          width="24"
          height="24"
          style="margin-right: 4px; cursor: pointer"
        />
      </viewer>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增人员' : '编辑人员'"
      width="1000"
      ref="formModel"
      fenlei
    >
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <Drawer title="人员转移" :closable="false" v-model="openTransferForm">
      <div id="zhuanyi">
        <group-tree
          btn
          @queding="transferCar"
          v-if="openTransferForm"
        ></group-tree>
      </div>
    </Drawer>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openDevice: false,
      openForm: false,
      isAdd: false,
      openTransferForm: false,
      columns: [
        {
          type: "selection",
          width: 70,
          align: "center",
          tooltip: true,
        },
        {
          type: "index",
          width: 70,
          align: "center",
        },

        {
          title: "创建者账号",
          key: "createAccount",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "创建时间",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      forms: [
        {
          title: "姓名",
          key: "name",
          multiple: true,
          type: "Input",
          required: true,
          span: 8,
          fenlei: "人员基本信息",
        },
        {
          title: "绑定账号",
          key: "userId",
          key1: "userAccount",
          type: "selectUser",
          span: 8,
          fenlei: "人员基本信息",
        },
        {
          title: "单位名称",
          key: "groupId",
          key1: "groupName",
          multiple: false,
          type: "selectGroup",
          required: true,
          minWidth: 200,
          maxWidth: 300,
          span: 8,
          fenlei: "人员基本信息",
        },
        {
          title: "设备号",
          key: "deviceNo",
          multiple: true,
          type: "Input",
          required: true,
          span: 8,
          fenlei: "设备信息",
        },
        {
          title: "sim卡号",
          key: "simNo",
          multiple: true,
          type: "Input",
          required: true,
          span: 8,
          fenlei: "设备信息",
        },
        {
          title: "设备类型",
          key: "deviceModel",
          type: "Select",
          selectItems: [],
          required: true,
          span: 8,
          fenlei: "设备信息",
        },
        {
          title: "电话",
          key: "tel",
          type: "Input",
          span: 8,
          fenlei: "更多人员信息",
        },
        {
          title: "其他联系方式",
          key: "contact",
          type: "Input",
          span: 8,
          fenlei: "更多人员信息",
        },
        {
          title: "身份证",
          key: "idCard",
          multiple: true,
          type: "Input",
          span: 8,
          fenlei: "更多人员信息",
        },
        {
          title: "性别",
          key: "sex",
          key2: "sex2",
          type: "Select1",
          st: "sex",
          span: 8,
          fenlei: "更多人员信息",
        },
        {
          title: "年龄",
          key: "age",
          type: "InputNumber",
          min: 1,
          max: 99,
          span: 8,
          fenlei: "更多人员信息",
        },
        {
          title: "职位",
          key: "job",
          type: "Input",
          span: 8,
          fenlei: "更多人员信息",
        },
        {
          title: "住址",
          key: "address",
          type: "Input",
          span: 8,
          fenlei: "更多人员信息",
        },
        {
          title: "照片",
          key: "pic",
          slot:'pic',
          type: "lyPhoto",
          one: true,
          span: 8,
          fenlei: "更多人员信息",
        },
        {
          title: "工号",
          key: "jobNo",
          type: "Input",
          span: 8,
          fenlei: "更多人员信息",
        },
        {
          title: "工龄",
          key: "jobAge",
          type: "InputNumber",
          min: 0,
          max: 99,
          span: 8,
          fenlei: "更多人员信息",
        },
        {
          title: "状态",
          key: "signState",
          key2: "signState2",
          type: "Select1",
          st: "signState",
          span: 8,
          fenlei: "更多人员信息",
        },
        {
          title: "入职日期",
          key: "entryDate",
          key2: "entryDate2",
          type: "lyyymmdd",
          span: 8,
          fenlei: "更多人员信息",
        },
        {
          title: "备注",
          key: "remark",
          type: "Input",
          type1: "textarea",
          span: 8,
          fenlei: "更多人员信息",
        },
      ],
      tableData: [],
      item: {
        deviceNo: "",
        deviceModel: "",
        simNo: "",
        groupId: "",
        groupName: "",
        userId: "",
        userAccount: "",
        entryDate: Date.now(),
        jobNo: "",
        model: "",
        simNo: "",
        sex: "0",
        signState: "1",
        pic: "",
      },
      ruleValidate: {
        groupName: { required: true, message: "必填" },
        simNo: { required: false, message: "必填" },
        deviceNo: { required: false, message: "必填" },
        name: { required: true, message: "必填" },
        model: { required: false, message: "必填" },
      },
      deviceTypeList: [],
      searchItem: {
        keyword: "",
        pageSize: 50,
        pageNumber: 1,
        groupIdList: [],
      },
      total: 0,
      selectCars: [],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.dm + "/person/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (const i in data) {
          data[i].entryDate2 = this.utils.time(data[i].entryDate, "yymmdd");
          data[i].signState = String(data[i].signState);
          data[i].sex = String(data[i].sex);
          data[i].sex2 = this.$t("sex." + data[i].sex);
          data[i].signState2 = this.$t("signState." + data[i].signState);
        }
        this.tableData = data;
        console.log(res);
      });
    },
    exportAll() {
      var params = [
        {
          name: "keyword",
          value: this.searchItem.keyword,
        },
        {
          name: "groupIdList",
          value: this.searchItem.groupIdList,
        },
      ];
      this.utils.exportData(axios.dm + "/person/export", params);
    },
    addUpdate(name) {
      var m = this.$refs.formModel.getItem();
      if (!m) {
        return;
      }
      this.item = m;
      var a = this.utils.isEmpty(this.item.deviceNo),
        b = this.utils.isEmpty(this.item.simNo),
        c = this.utils.isEmpty(this.item.deviceModel);
      if (!((a && b && c) || (!a && !b && !c))) {
        this.$Message.error("设备信息不完整");
        return;
      }
      if (a && b && c) {
        this.item.device = null;
      } else {
        this.item.device = {
          deviceNo: this.item.deviceNo,
          simNo: this.item.simNo,
          model: this.item.deviceModel,
        };
      }
      if (this.isAdd) {
        axios({
          method: "post",
          url: axios.dm + "/person/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        axios({
          method: "post",
          url: axios.dm + "/person/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.dm + "/person/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.openForm = true;
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    reDevice(v) {
      this.item.deviceNo = v.deviceNo;
      this.item.deviceId = v.id;
      this.openDevice = false;
    },
    getDictionary() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: "/dictionary/item",
        data: {
          keyword: "deviceModel",
        },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = JSON.parse(res.data.data.value);
        var arr = [];
        for (let i = 0; i < data.length; i++) {
          arr.push(data[i].name);
        }
        this.forms[5].selectItems = arr;
      });
    },
    search() {
      this.getList();
    },
    getDeList(y) {
      var x = this.selectCars;
      if (x.length == 0) {
        this.$Message.error("至少选择一个人");
        return;
      }
      if (y == 1) {
        this.openTransferForm = true;
      } else {
        this.$refs.carLabel.reachData(x);
      }
    },
    transferCar(v) {
      var idList = [],
        a = this.selectCars;
      for (let i = 0; i < a.length; i++) {
        idList[i] = a[i].id;
      }
      axios({
        method: "post",
        url: axios.dm + "/person/shift",
        data: {
          groupId: v[0].id,
          idList: idList,
        },
      }).then((res) => {
        console.log(res);
        if (res) {
          this.openTransferForm = false;
          this.getList();
          this.selectCars = [];
        }
      });
    },
    cols() {
      var b = JSON.parse(JSON.stringify(this.forms));
      //b.splice(2, 4);
      for (let i = 0; i < b.length; i++) {
        if (!b[i].minWidth && !b[i].maxWidth) {
          b[i].minWidth = 100;
          b[i].maxWidth = 200;
        }
        if (b[i].key1) {
          b[i].key = b[i].key1;
        }
        if (b[i].key2) {
          b[i].key = b[i].key2;
        }
      }
      this.columns.splice(1, 0, ...b);
      console.log(this.columns);
      //a.splice.apply(a,[i,0].concat(b));//es5写法
    },
  },
  mounted() {
    this.cols();
    this.getList();
    this.getDictionary();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/information/person.vue